export const PLANS_TEST_IDS = {
    TELIA1_TOGGLE: 'plans-list-telia1-toggle',
    CONSENT_CHECKBOX: 'plans-list-consent-checkbox',
    ACCEPT_CONSENT_BUTTON: 'plans-list-accept-consent-button',
    VIEW_OFFERS_BUTTON: 'plans-list-view-offers-button',
    GET_OFFER_BUTTON: 'plans-list-get-offer-button',
};
